module.exports = __webpack_public_path__ + "img/R.86a2d785.png";